import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/global.css'

const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming
if (navEntry?.type === 'reload') {
    sessionStorage.clear()
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <App />
)
